/**
 * DietaryTag - synchronized with Prisma schema.
 *
 * Proprietà della ricetta, non del menù: lo stesso piatto non può essere vegano
 * a pranzo e non vegano a cena.
 *
 * GLUTEN_FREE non è mai inferito dall'AI. È un claim regolamentato dal
 * Reg. UE 828/2014 (soglia 20 mg/kg) che dipende anche dalla contaminazione
 * crociata in cucina: nessuna inferenza sugli ingredienti può conoscerla.
 * Resta una dichiarazione manuale dell'operatore.
 *
 * Const object e non `enum`, come le enum generate da Prisma: i valori che
 * arrivano dal wire sono stringhe e devono restare assegnabili senza cast.
 */
export const DietaryTag = {
  VEGETARIAN: 'VEGETARIAN',
  VEGAN: 'VEGAN',
  GLUTEN_FREE: 'GLUTEN_FREE',
} as const;

export type DietaryTag = (typeof DietaryTag)[keyof typeof DietaryTag];
